import React from 'react'
import Responsive from 'react-responsive'

export const Default = props => <Responsive {...props} minWidth={768} />;
export const Tablet = props => <Responsive {...props} minWidth={768} maxWidth={1199} />;
export const Laptop = props => <Responsive {...props} minWidth={1200} maxWidth={1476} />;
export const Mobile = props => <Responsive {...props} maxWidth={767} />;
